import React from 'react';

const NotFound = () => {
    return (
        <div>
            <img width="800px" src="https://img.freepik.com/free-vector/404-error-with-landscape-concept-illustration_114360-7888.jpg?w=2000" alt="" />
        </div>
    );
};

export default NotFound;